import script from "./PlayButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayButton.vue?vue&type=script&setup=true&lang=ts"

import "./PlayButton.vue?vue&type=style&index=0&id=8118fe64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8118fe64"]])

export default __exports__